import { Avatar, Button, SxProps, Typography } from '@mui/material';
import { DynamicArrow } from 'Components/DynamicArrow';
import { useIsDesktop } from 'Hooks';

interface INextPrevButton {
  text: string;
  isNext?: boolean;
  callback: Function;
  isBlue?: boolean;
  style?: {
    button?: SxProps;
    text?: SxProps;
    image?: SxProps;
  };
  hideArrowIcon?: boolean;
  icon?: {
    src: string;
    sx?: SxProps;
  };
  isDisabled?: boolean;
}

export const NextPrevButton = ({
  text,
  callback,
  isNext,
  isBlue,
  style,
  hideArrowIcon,
  icon,
  isDisabled,
}: INextPrevButton) => {
  const isDesktop = useIsDesktop();

  const buttonStyle = isBlue
    ? {
        backgroundColor: 'primary.shade_400',
        boxShadow: '0px 2px 16px rgba(4, 16, 46, 0.08)',
        borderRadius: '100px',
        gap: '3px',
        padding: '12px 24px',
        width: '235px',
        ':hover': {
          background: '#1f51cc',
          cursor: 'pointer',
        },
      }
    : {
        backgroundColor: 'white',
        boxShadow: '0px 2px 16px rgba(4, 16, 46, 0.08)',
        borderRadius: '100px',
        outline: '1px solid',
        outlineColor: isDesktop ? 'primary.shade_400' : 'primary.shade_200',
        gap: '3px',
        padding: '12px 24px',
        width: '235px',
        ':hover': {
          background: '#d1cdcd',
          cursor: 'pointer',
        },
      };

  return (
    <Button
      sx={{
        flexDirection: isNext ? 'row' : 'row-reverse',
        maxHeight: isDesktop ? '46px' : '40px',
        ':focus': {
          outline: '1px solid black',
        },
        ...buttonStyle,
        ...style?.button,
      }}
      onClick={() => callback()}
      disabled={isDisabled}
    >
      <Typography
        sx={{
          color: isBlue ? 'white' : 'primary.main',
          ...style?.text,
        }}
        variant={isDesktop ? 'body4' : 'body1'}
      >
        {text}
      </Typography>
      {icon && <Avatar alt='' src={icon.src} sx={{ ...icon.sx }} />}
      {!hideArrowIcon && (
        <Avatar
          alt=''
          sx={{
            bgcolor: 'transparent',
            transform: `rotate(${isNext ? '90deg' : '-90deg'})`,
            mt: '2px',
            width: 'fit-content',
            ...style?.image,
          }}
        >
          <DynamicArrow color={isBlue ? 'white' : '#1552E8'} />
        </Avatar>
      )}
    </Button>
  );
};
